<template>
    <div class="reportList">
      <div class="content-container">
        <div class="titieMian">
          <div class="title-container">报告管理</div>
          <div class="select-container">
            <div class="select-container-box">
              <span>类型</span>
              <el-select v-model="type" filterable  size="small">
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="select-container-box">
              <span>输入查询</span>
              <el-input
                placeholder="请输入关键字"
                v-model="keyword"
                :maxlength="num"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                size="small"
                class="search-input"
                clearable>
              </el-input>
            </div>
            <div class="select-container-box">
              <el-button size="small"  type="info" plain  class="query" @click="search()">查询</el-button>
              <el-button size="small"  type="info" plain @click="add()" class="add" style="background:#FF812D">添加</el-button>
            </div>  
          </div>
        </div>  
        <div class="table-container">
          <el-table
            :data="list"
            style="width:100%"
            size="medium"
            @row-dblclick="dataBackFillGoods"
            :default-sort = "{prop: 'date', order: 'descending'}">
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
            <el-table-column
              type="index"
              width="120"
              align="center"
              label="序号"
              >
            </el-table-column>
              <el-table-column
              prop="organizationName"
              label="机构名称"
              show-overflow-tooltip
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="reportNumber"
              label="检测编号"
              align="center"
              show-overflow-tooltip
              >
            </el-table-column>
            <el-table-column
              prop="inspector"
              label="质检员"
              align="center"
              show-overflow-tooltip
              >
            </el-table-column>
            <el-table-column
              prop="inspectionTime"
              align="center"
              label="更新时间"
          >
            </el-table-column>
          
            <el-table-column
              prop="modifierName"
              align="center"
              label="更新人"
              >
            </el-table-column>
            <el-table-column label="操作" align="center" >
              <template slot-scope="scope">
                <span
                  class="content-edit"
                  @click="handleEdit(scope.$index, scope.row)">编辑</span>
                <span
                  class="content-del"
                  @click="handleDelete(scope.$index, scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <page-change :pageInfo="pageInfo"></page-change>
      </div>
    </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import PageChange from "../../common/PageChange";
export default {
  name: "reportList",
  components: {
    PageChange
  },
  data() {
    return {
      num: 20,
      type: 1,
      typeList: [
        {
          value: 1,
          label: "机构名称"
        },
        {
          value: 2,
          label: "检测编号"
        },
        {
          value: 3,
          label: "质检员"
        }
      ],
      list: [],
      keyword: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    //查询
    search(pageNum) {
      let obj = {
        Type: this.type,
        Keyword: this.keyword,
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize
      };
      this.$api
        .getInspectionReportList(obj)
        .then(rsp => {
          if (rsp.status === 200 && rsp.data.list.length > 0) {
            rsp.data.list.map(item => {
              item.inspectionTime = item.inspectionTime.substring(0, 10);
            });
            this.list = rsp.data.list;
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      this.$router.push({
        name: "editReport",
        query: {
          id: row.id
        }
      });
    },
    //添加
    add() {
      this.$router.push({
        name: "addReport"
      });
    },
    //编辑页面
    handleEdit(index, row) {
      this.$router.push({
        name: "editReport",
        query: {
          id: row.id
        }
      });
    },
    //删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.$api.deleteInspectionReport(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
  .reportList .content-container .titieMian .select-container{
    margin-top:-5px; 
  }
</style>
